<template>
<div class="result-picker">   
    <span class="label">{{$t("selected_product")}}:</span>
    <div v-if="results.length > 0" class="selected-list" :class="{'open': open}" id="selected-list">
        <div class="selection" @click="toggleList()">{{selected}}</div>
        <div class="list">
            <div>
                <table>
                    <tr v-for="(result, index) in results" 
                            :key="index">
                        <td class="label" @click="setActiveTab(index)" :class="{highlight: index == $store.state.search.selectedResult}">
                            {{result.result.type === 'lamp' ? result.result.material_description : result.result.product_description}}
                        </td>
                        <td class="delete" @click="removeSelected($event, index)">&#215</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>
</template>


<script>
import Vue from 'vue';

export default {
    name: "ResultPicker",

    data: function() {
        return {
            open: false,
        }
    },

    computed: {
        results() {
            const results = this.$store.state.search.results;
            return results;
        },

        selected() {
            let a = this.results[this.$store.state.search.selectedResult];
            if (a === undefined)
                return "...";
            return a.result.type === 'lamp' ? a.result.material_description : a.result.product_description;
        }
    },

    methods: {
        toggleList() {
            if (this.open) {
                this.closeList();
            }
            else {
                Vue.nextTick().then(() => {
                    window.addEventListener('click', this.closeClickHandler);
                });
                this.open = true;
            }
        },

        closeList() {
            this.open = false;
            window.removeEventListener('click', this.closeClickHandler);
        },

        closeClickHandler(event) {
            const trigger = document.querySelector(`#selected-list`);

            if(trigger.contains(event.target)) { 
                return;
            }

            this.closeList()
        },


        // Selection operations

        setActiveTab(index) {
            this.closeList();
            this.$store.dispatch("search/setSelectedResult", index);
        },

        removeSelected(e, index) {
            e.stopPropagation();
            this.closeList();
            this.$store.dispatch("search/removeResult", index);
        }
    }
    
}
</script>



<style lang="scss" scoped>
.result-picker {
    display: flex;
    align-items: center;

    >span {
        white-space: nowrap;
        margin-right: 15px;

        @include media-breakpoint-down(lg) {
            display: none;
        }
    }
}

.selected-list {
    position: relative;
    display: inline-block;
    width: 300px;

    @include media-breakpoint-down(md) {
        width: 140px;
    }

    @include media-breakpoint-down(sm) {
        width: 100%;
    }
}

.list {
    display: none;
}

.selected-list.open {
    .list {
        background-color: white;
        display: block;
        border: $nc-gray-border;
        position: absolute;
        right: 0;
        min-width: 100%;
        text-overflow: ellipsis;
        overflow-y: auto;
        white-space: nowrap;

        >div {
            overflow: auto;
            max-height: 116px;
            
        }

        table {
            min-width: 100%;

            @include media-breakpoint-down(sm) {
                min-width: 100%;
            }
        }
        
        tr {
            justify-content: space-between;
            cursor: pointer;

            &:last-child {
                border-bottom: none;
            }

            .delete {
                width: 30px;
                min-width: 30px;
                flex-basis: 30px;
                text-align: center;
                padding-top: 0em;
                overflow: hidden;
                right: 0;
                background-color: white;
                font-size: 30px;
                line-height: 10px;
            }
            
            >*:hover {
                background-color: $nc-blue-primary;
                color: white;
            }
        }

        td.label {
            display: block;
            padding: 4px 6px;

            &:hover {
                color: white;
            }
        }
        td.label.highlight {
            background-color: $nc-blue-primary;
            color: white;
        }
    }

    .selection {
        &:after {
            transform: rotate(180deg);
            top: 0.5em;
        }
    }
}



.selection {
    position: relative;
    padding: 5px 30px 5px 5px;
    box-sizing: border-box;
    border: $nc-gray-border;
    text-overflow: ellipsis;
    white-space: nowrap; 
    overflow: hidden;

    cursor: pointer;

    &:after {
        content: "";
        position: absolute;
        width: 12px;
        height: 12px;
        top: 0.8em;
        right: 5px;
        background: url('../assets/svg/caret.svg') no-repeat;
    }
}
</style>
